import React, { PropsWithChildren } from 'react';

// `actions` fills the right side of the header of a large Portlet (for example a status and a switch).
// A Portlet without `actions` looks as before.
const Portlet: React.FunctionComponent<PropsWithChildren<{
	title?: string,
	note?: string | React.ReactNode,
	isLarge?: boolean,
	actions?: React.ReactNode,
}>> = ({ title, note, isLarge, actions, children }) => {
	const hasNote = note !== undefined && note !== null && note !== '' && note !== false;

	if (isLarge === true)
		return <div className="divide-y divide-gray-200 rounded-lg bg-white shadow">
			<div className="px-4 py-5 sm:px-6">
				<div className="flex flex-wrap items-center justify-between sm:flex-nowrap min-h-9.5">
					<div className="flex items-center">
						<h3 className="text-lg font-semibold leading-6 text-gray-900">{title}</h3>
						{hasNote && <div className="text-xs font-medium text-gray-400">{note}</div>}
					</div>
					{actions === undefined
						? <div className="flex-shrink-0"></div>
						: <div className="mt-2 flex w-full flex-wrap items-center gap-3 sm:ml-4 sm:mt-0 sm:w-auto sm:flex-shrink-0 sm:flex-nowrap">{actions}</div>}
				</div>
			</div>
			<div className="px-4 py-5 sm:p-6">
				{children}
			</div>
		</div>;

	else return <div className="rounded-lg bg-white shadow p-4">
		<div className="flex justify-between items-center mb-3">
			<h2 className="text-base font-semibold text-gray-900">{title}</h2>
			{hasNote && <div className="text-xs font-medium text-gray-400">{note}</div>}
		</div>
		<div className="wrapper">
			{children}
		</div>
	</div>;
};

export default Portlet;
